
import React, { useState } from 'react';
// import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import './down.css';
import ArrowDown from '../../img/ArrowDown.png'


const Down = ({ title, children, isNoneDown, name }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>

      {!isNoneDown ? (
        <>
          <div className="container_down">
            <div className="down_title">{title}</div>
            <div>{children}</div>
          </div>
        </>
      ) : (<>
        <div className="container_down" onClick={() => setIsOpen(!isOpen)}>
          <div className="down_title_revers">
            <div>
              <div>
                {title}
              </div>
              <div className="name_down">{name}</div>
            </div>
            <img src={ArrowDown} alt="arow" className={isOpen ? 'top' : 'booton'} />
          </div>
          <div className={isOpen ? 'display_none' : 'content_children_show'}>{children}</div>
        </div>

      </>)}
    </>

  )
}

export default Down;